<template>
	<div>
		<small>Forgot the password?
			<span id="resetPassSpan"
			 @click="passResetDialog = true">
				Reset password here
			</span>
		</small>
		<v-dialog v-model="passResetDialog"
		 persistent
		 width="50%">
			<v-card>
				<v-card-title primary-title>
					<v-flex>
						<div>
							<h3 class="headline ">Please provide the email you registered in the app with</h3>
						</div>
					</v-flex>
				</v-card-title>
				<v-divider></v-divider>
				<form action='submit'
				 method="post">
					<v-card-text>
						<v-layout wrap>
							<v-flex xs12>
								<v-text-field label="email"
								 type='email'
								 v-model="passResetRequestEmail">
								</v-text-field>
							</v-flex>
						</v-layout>
					</v-card-text>
					<v-card-actions>
						<v-flex>
							<v-btn flat
							 :disabled="isLoading"
							 color="primary"
							 @click="closePasswordReset">
								Close
							</v-btn>
							<v-btn flat
							 :loading="isLoading"
							 :disabled="isLoading"
							 color="primary"
							 @click="sendPasswordResetEmail">
								Submit
							</v-btn>
						</v-flex>
					</v-card-actions>
				</form>
				<v-alert color="red"
				 transition="scale-transition"
				 :value="noSuchEmailForPassReset"
				 class="text-xs-center">
					Oh snap! It appears there is no such email within the app... Try again with a correct email address you registered with in ULA.
				</v-alert>
				<v-alert transition="scale-transition"
				 :value="passResetEmailSent"
				 color="success"
				 class="text-xs-center">
					Email sent! Expect it to appear within 15min at most ! :)
				</v-alert>
			</v-card>
		</v-dialog>
	</div>
</template>

<script>
export default {
  name: "passwordResetDialog",
  data() {
    return {
      passResetRequestEmail: "",
      passResetDialog: false,
      noSuchEmailForPassReset: false,
      passResetEmailSent: false
    };
  },
  methods: {
    closePasswordReset() {
      this.passResetRequestEmail = "";
      this.passResetDialog = false;
      this.noSuchEmailForPassReset = false;
      this.passResetEmailSent = false;
    },
    sendPasswordResetEmail() {
      this.$store
        .dispatch("sendPasswordResetEmail", this.passResetRequestEmail)
        .then(res => {
          if (!res) {
            this.noSuchEmailForPassReset = true;
          } else {
            this.noSuchEmailForPassReset = false;
            this.passResetRequestEmail = "";
            this.passResetEmailSent = true;
            setTimeout(() => {
              this.passResetDialog = false;
            }, 3000);
          }
        });
    }
  },
  computed: {
    isLoading() {
      return this.$store.state.loadingState;
    }
  }
};
</script>

<style lang="scss" scoped>
small {
  color: #636363;
}
#resetPassSpan {
  cursor: pointer;
  color: #ee44aa;
  text-decoration: underline;
}
</style>